import apiClient from '@/utils/api';
import type { EnglishLevelId } from '@/constant/EnglishLevels';

// Auth API endpoints
export const authApi = {
  login: async (email: string, password: string) => {
    const response = await apiClient.post('/auth/login', { email, password });
    return response.data;
  },
  googleAuth: async (idToken: string, defaultReadLevel?: EnglishLevelId, referralCode?: string) => {
    const response = await apiClient.post('/auth/google', {
      idToken,
      defaultReadLevel,
      referralCode,
    });
    return response.data;
  },
  register: async (
    name: string,
    email: string,
    password: string,
    defaultReadLevel: EnglishLevelId,
    captchaToken: string,
    referralCode?: string
  ) => {
    const response = await apiClient.post('/auth/register', {
      name,
      email,
      password,
      defaultReadLevel,
      captchaToken,
      referralCode,
    });
    return response.data;
  },
  logout: async () => {
    const response = await apiClient.post('/auth/logout');
    return response.data;
  },
  getCurrentUser: async () => {
    const response = await apiClient.get('/auth/me');
    return response.data;
  },
  updateCurrentUser: async (payload: { name?: string; defaultReadLevel?: EnglishLevelId }) => {
    const response = await apiClient.put('/auth/me', payload);
    return response.data;
  },
  changePassword: async (payload: { currentPassword?: string; newPassword: string }) => {
    const response = await apiClient.put('/auth/password', payload);
    return response.data;
  },
  requestPasswordReset: async (email: string) => {
    const response = await apiClient.post('/auth/forgot-password', { email });
    return response.data;
  },
  resetPassword: async (payload: { email: string; token: string; newPassword: string }) => {
    const response = await apiClient.post('/auth/reset-password', payload);
    return response.data;
  },
  verifyEmail: async (payload: { email: string; token: string }) => {
    const response = await apiClient.post('/auth/verify-email', payload);
    return response.data;
  },
  resendActivationEmail: async (email: string) => {
    const response = await apiClient.post('/auth/resend-activation-email', { email });
    return response.data;
  },
};
